"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  width: 80%;
  height: 25px;
`;
const PaymentInfo = _ref => {
  let {
    payment
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    justify: "between",
    marginTop: 10
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 2,
    text: _services.Services.locale.localeString('AccessoryModal.PayUpfront'),
    appearance: "secondary"
  }), (payment === null || payment === void 0 ? void 0 : payment.upfront) >= 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    text: _services.Services.locale.formatPrice(payment.upfront),
    weight: 3
  })), /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    justify: "between"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 2,
    text: "Monthly",
    appearance: "secondary"
  }), (payment === null || payment === void 0 ? void 0 : payment.monthlyPrice) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, _services.Services.locale.formatPrice(payment.monthlyPrice), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 2
  }, "\xA0", _services.Services.locale.localeString('AccessoryModal.For'), "\xA0", (payment === null || payment === void 0 ? void 0 : payment.monthlyPeriod) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, payment.monthlyPeriod), "\xA0", _services.Services.locale.localeString('AccessoryModal.Months')))), /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    appearance: "secondary",
    size: 1,
    weight: 2
  }, _services.Services.locale.localeString('AccessoryModal.Credits')))));
};
var _default = PaymentInfo;
exports.default = _default;